/**
 * Douyin Tab 常量
 *
 * - DOUYIN_TABLE_METRICS：表格 4 列指标（Views / Likes / Shares / Comments）
 * - DOUYIN_SORT_OPTIONS：Sort By / 表格排序（与 API sort_item 白名单一致）
 */

import { TipsMapType } from '@op/components/BubbleCommon';
import { videoDouyinViewsTipsMap } from '@opm/components/BubbleCommon';

export interface IDouyinMetricItem {
  key: string;
  label: string;
  tipsMap?: TipsMapType;
}

/** 表格指标列 — API sort_item：view_count / like_count / share_count / comment_count */
export const DOUYIN_TABLE_METRICS: IDouyinMetricItem[] = [
  { key: 'like_count', label: 'Likes' },
  { key: 'view_count', label: 'Views', tipsMap: videoDouyinViewsTipsMap },
  { key: 'share_count', label: 'Shares' },
  { key: 'comment_count', label: 'Comments' },
];

/** Sort By / 表格列排序（卡片与表格共用，避免切换视图时 sort key 不一致） */
export const DOUYIN_SORT_OPTIONS: Array<{ text: string; value: string }> = [
  { text: 'Date', value: 'publish_time' },
  ...DOUYIN_TABLE_METRICS.filter(item => item.key !== 'view_count').map(
    metric => ({
      text: metric.label,
      value: metric.key,
      tipsMap: metric.tipsMap || undefined,
    }),
  ),
];

export const DOUYIN_DEFAULT_SORT = {
  by: 'like_count',
  order: 'desc' as const,
};
